// src/components/layout/Layout.jsx
import React, { useState, useContext, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import SidebarContent from '../Navbar/Sidebar1';
import { useOrganizations } from '../../customHooks';
import { Navbar } from '../Navbar';
import { ColorModeContext } from '../../index';  // bring in the context

export const Layout = () => {
  const { sidebarModules } = useOrganizations();
  const [openSidebar, setOpenSidebar] = useState(true);
  const handleSidebarOpen = () => setOpenSidebar(prev => !prev);

  // Consume the color mode context
  const { mode, toggleColorMode } = useContext(ColorModeContext);

  const location = useLocation();

  useEffect(() => {
    const rawPath = location.pathname.replace(/^\//, '').toLowerCase();
    const routeTitles = {
      '': 'Dashboard',
      'home': 'Dashboard',
      'dashboard': 'Dashboard',
      'users': 'Users',
      'user-management': 'User Management',
      'roles': 'Roles',
      'role': 'Role Master',
      'permissions': 'Permissions',
      'permission': 'Permission Master',
      'policies': 'Policies',
      'groups': 'Groups',
      'devices': 'MFA Devices',
      'windows-agent-devices': 'Windows Agent Devices',
      // Retired: AD sync now runs through the gateway page
      // 'admin/ad-integration': 'Active Directory Integration',
      // 'ad-integration': 'Active Directory Integration',
      'applications': 'Applications',
      'admin/scim': 'SCIM Integrations',
      'scim': 'SCIM Integrations',
      'asset': 'Asset Firmware',
      'profile': 'Profile',
      'notifications': 'Notifications',
      'scheduler': 'Scheduler',
      'email-scheduler': 'Email Scheduler',
      'scheduler1': 'Scheduler',
      'bulk-import': 'Bulk Import',
      'reports': 'Reports',
      'whitelisturls': 'Whitelist URLs',
      'protocol-rules': 'Protocol Rules',
      'active-sessions': 'Active Sessions',
      'questionnaire': 'Questionnaire',
      'no-access': 'No Access',
      'access-denied': 'Access Denied',
    };

    let pageTitle = routeTitles[rawPath];
    if (!pageTitle && rawPath) {
      const segment = rawPath.split('/').filter(Boolean).pop() || '';
      pageTitle = segment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    if (pageTitle) {
      document.title = `${pageTitle} | mAuthenticate MFA`;
    } else {
      document.title = 'mAuthenticate MFA - Modern Multi-Factor Authentication System';
    }
  }, [location.pathname]);

  return (
    <Grid container sx={{ height: '100vh', backgroundColor: mode === 'dark' ? '#0F1729' : '#FFFFFF' }}>
      {sidebarModules && (
        <Grid
          item
          sx={{
            width: openSidebar ? '250px' : '70px',
            background: mode === 'dark' ? '#0B1527' : '#0B2545',
            borderRight: '1px solid',
            borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'grey.300',
            height: '100%',
            overflow: 'auto',
            transition: 'width 0.3s ease',
            display: 'block',
            '&::-webkit-scrollbar': {
              width: '5px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: 'rgba(255, 255, 255, 0.3)',
            },
          }}
        >
          <SidebarContent
            sidebarModules={sidebarModules}
            openSidebar={openSidebar}
            setOpenSidebar={setOpenSidebar}
          />
        </Grid>
      )}

      <Grid
        item
        flex={1}
        sx={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' }}
      >
        {/* Pass mode & toggleMode into Navbar */}
        <Navbar
          showSideBarOption={!!sidebarModules}
          handleSidebarOpen={handleSidebarOpen}
          mode={mode}
          toggleMode={toggleColorMode}
          openSidebar={openSidebar}
        />

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', px: '40px', py: '24px' }}>
          <Outlet />
        </Box>
      </Grid>
    </Grid>
  );
};
